import { render, staticRenderFns } from "./CatalogImage.vue?vue&type=template&id=f3043804"
import script from "./CatalogImage.vue?vue&type=script&lang=js"
export * from "./CatalogImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports